var _path, _path2, _path3, _path4, _path5, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEsExpenses(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.118 134.119C108.23 134.119 135.883 106.466 135.883 72.3543C135.883 38.2426 108.23 10.5896 74.118 10.5896C40.0063 10.5896 12.3533 38.2426 12.3533 72.3543C12.3533 106.466 40.0063 134.119 74.118 134.119Z",
    fill: "#C6D4E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3566 129.139C15.6222 130.993 16.5315 133.091 18.3501 133.826C20.1687 134.56 22.2671 133.686 23.0015 131.832C23.736 130.014 22.8616 127.88 21.043 127.146C19.2244 126.412 17.091 127.286 16.3566 129.139Z",
    fill: "#C6D4E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126.905 17.3005C127.64 15.4469 126.73 13.3485 124.912 12.6141C123.093 11.8796 120.995 12.754 120.26 14.6076C119.526 16.4262 120.4 18.5595 122.219 19.294C124.037 20.0284 126.171 19.1541 126.905 17.3005Z",
    fill: "#C6D4E7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7606 122.32C10.271 123.474 10.8655 124.838 12.0546 125.293C13.2087 125.747 14.5377 125.188 15.0273 124.034C15.482 122.88 14.9574 121.516 13.7683 121.061C12.5792 120.571 11.2152 121.131 10.7606 122.32Z",
    fill: "#C6D4E7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M132.501 24.1203C132.991 22.9661 132.396 21.6022 131.207 21.1475C130.053 20.6929 128.724 21.2524 128.235 22.4066C127.78 23.5607 128.304 24.9246 129.494 25.3793C130.683 25.8689 132.047 25.3093 132.501 24.1203Z",
    fill: "#C6D4E7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12189_16868)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127 34.4791V108.521C127 110.981 125.005 113 122.528 113H26.4721C23.9946 113 22 111.002 22 108.521V34.4791C22 31.9977 23.9946 30 26.4721 30H122.549C125.005 30 127 31.9977 127 34.4791Z",
    fill: "url(#paint0_linear_12189_16868)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127 34.4791V45.1616H53.5777C52.8008 45.1616 52.087 44.7831 51.6461 44.1312L48.7906 39.9255C48.3497 39.2736 47.6359 38.8951 46.859 38.8951H36.781C36.0042 38.8951 35.2903 39.2736 34.8494 39.9255L31.994 44.1312C31.5531 44.7831 30.8392 45.1616 30.0624 45.1616H22V34.4791C22 31.9977 23.9946 30 26.4721 30H122.528C125.005 30 127 31.9977 127 34.4791Z",
    fill: "url(#paint1_linear_12189_16868)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.1 37.591C121.1 39.1261 119.84 40.3878 118.308 40.3878C116.775 40.3878 115.515 39.1261 115.515 37.591C115.515 36.0559 116.775 34.7942 118.308 34.7942C119.861 34.7732 121.1 36.0349 121.1 37.591Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.87 37.591C112.87 39.1261 111.61 40.3878 110.077 40.3878C108.545 40.3878 107.285 39.1261 107.285 37.591C107.285 36.0559 108.545 34.7942 110.077 34.7942C111.631 34.7732 112.87 36.0349 112.87 37.591Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.66 37.591C104.66 39.1261 103.401 40.3878 101.868 40.3878C100.335 40.3878 99.0756 39.1261 99.0756 37.591C99.0756 36.0559 100.335 34.7942 101.868 34.7942C103.401 34.7732 104.66 36.0349 104.66 37.591Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6212 54.4748C75.5997 52.7334 82.6376 53.8348 88.4982 57.0807L83.5296 65.6932C79.8814 63.7054 75.5161 63.029 71.1844 64.0633L68.6212 54.4748Z",
    fill: "#E4EFFF",
    stroke: "#C6D4E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3497 71.9381L51.7521 66.9705C55.2087 61.2203 60.7489 56.7185 67.66 54.7285L70.2232 64.3169C65.9558 65.5923 62.5123 68.3669 60.3497 71.9381Z",
    fill: "white",
    stroke: "#C6D4E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5584 104.837L61.5574 104.836C55.6119 101.401 50.9654 95.7491 48.9395 88.6806L58.518 86.108C59.8398 90.551 62.7816 94.1002 66.5322 96.2479C70.3928 98.4782 75.1272 99.229 79.7907 97.9765C84.4556 96.7236 88.1567 93.7061 90.4101 89.8355L90.4111 89.8338C92.6409 85.9687 93.419 81.2218 92.1706 76.5519C90.9687 72.0559 88.132 68.4553 84.4728 66.1826L89.4414 57.57C95.2472 61.1248 99.7905 66.8509 101.693 73.9691C103.649 81.2852 102.446 88.7077 98.956 94.792C95.4429 100.882 89.6391 105.606 82.3298 107.569C75.0199 109.532 67.614 108.355 61.5584 104.837Z",
    fill: "white",
    stroke: "#C6D4E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8244 72.7671C57.8621 76.4329 57.1775 80.7844 58.2079 85.1214L48.6047 87.7006C46.8676 80.7287 47.9714 73.6729 51.2212 67.7962L59.8244 72.7671Z",
    fill: "#C6D4E7",
    stroke: "#C6D4E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1817 59.5129C83.1397 59.5129 83.0977 59.4919 83.0558 59.4709C82.9298 59.4078 82.9088 59.2396 82.9718 59.1344L87.9268 50.9543C87.9688 50.8702 88.0528 50.8281 88.1367 50.8281H102.729C102.876 50.8281 102.981 50.9333 102.981 51.0805C102.981 51.2277 102.876 51.3328 102.729 51.3328H88.2837L83.3917 59.3868C83.3497 59.4709 83.2657 59.5129 83.1817 59.5129Z",
    fill: "#C6D4E7",
    stroke: "#C6D4E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.981 46.9262V48.4823C102.981 48.6295 102.876 48.7346 102.729 48.7346H98.1097C97.9838 48.7346 97.8578 48.6295 97.8578 48.4823V46.9262C97.8578 46.8 97.9628 46.6738 98.1097 46.6738H102.729C102.855 46.6738 102.981 46.779 102.981 46.9262Z",
    fill: "#C6D4E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0492 63.1624C58.9652 63.1624 58.8813 63.1203 58.8393 63.0362L53.9472 54.9822H39.5021C39.3552 54.9822 39.2502 54.8771 39.2502 54.7299C39.2502 54.5827 39.3552 54.4775 39.5021 54.4775H54.0942C54.1782 54.4775 54.2622 54.5196 54.3042 54.6037L59.2592 62.7838C59.3222 62.91 59.3012 63.0572 59.1752 63.1203C59.1542 63.1624 59.0912 63.1624 59.0492 63.1624Z",
    fill: "#C6D4E7",
    stroke: "#C6D4E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2714 50.5756V52.1317C39.2714 52.2789 39.3763 52.384 39.5233 52.384H44.1424C44.2684 52.384 44.3943 52.2789 44.3943 52.1317V50.5756C44.3943 50.4494 44.2894 50.3232 44.1424 50.3232H39.5233C39.3763 50.3232 39.2714 50.4284 39.2714 50.5756Z",
    fill: "#C6D4E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4121 88.4665C54.3282 88.4665 54.2442 88.5086 54.2022 88.5927L49.3102 96.6467H34.865C34.7181 96.6467 34.6131 96.7518 34.6131 96.899C34.6131 97.0462 34.7181 97.1514 34.865 97.1514H49.4571C49.5411 97.1514 49.6251 97.1093 49.6671 97.0252L54.6221 88.8451C54.6851 88.7189 54.6641 88.5717 54.5381 88.5086C54.4961 88.4876 54.4541 88.4665 54.4121 88.4665Z",
    fill: "#C6D4E7",
    stroke: "#C6D4E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.634 92.4506V94.0067C34.634 94.1539 34.739 94.259 34.886 94.259H39.5051C39.631 94.259 39.757 94.1539 39.757 94.0067V92.4506C39.757 92.3244 39.652 92.1982 39.5051 92.1982H34.886C34.739 92.1982 34.634 92.3244 34.634 92.4506Z",
    fill: "#C6D4E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.295 101.595H96.703C96.619 101.595 96.5351 101.553 96.4931 101.469L91.5381 93.2889C91.4751 93.1627 91.4961 93.0155 91.622 92.9524C91.748 92.8893 91.895 92.9104 91.958 93.0365L96.85 101.09H111.295C111.442 101.09 111.547 101.196 111.547 101.343C111.547 101.49 111.442 101.595 111.295 101.595Z",
    fill: "#C6D4E7",
    stroke: "#C6D4E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.547 98.5184V96.9623C111.547 96.8151 111.442 96.71 111.295 96.71H106.676C106.55 96.71 106.424 96.8151 106.424 96.9623V98.5184C106.424 98.6446 106.529 98.7708 106.676 98.7708H111.295C111.442 98.7708 111.547 98.6656 111.547 98.5184Z",
    fill: "#C6D4E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9174 94.9654C82.6037 94.9654 88.8347 88.7051 88.8347 80.9827C88.8347 73.2603 82.6037 67 74.9174 67C67.231 67 61 73.2603 61 80.9827C61 88.7051 67.231 94.9654 74.9174 94.9654Z",
    fill: "url(#paint2_linear_12189_16868)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5436 86.6007C79.9338 87.2539 78.8256 87.2783 78.1537 86.6063L74.9239 83.3765L71.6789 86.6214C71.0256 87.2748 69.9609 87.299 69.2889 86.627C68.6386 85.9767 68.6194 84.9122 69.3162 84.2587L72.5611 81.0138L69.3097 77.7623C68.6594 77.112 68.6402 76.0475 69.2935 75.3941C69.9469 74.7408 71.0332 74.7382 71.6835 75.3885L74.9133 78.6183L78.1582 75.3734C78.8116 74.72 79.8979 74.7175 80.5482 75.3678C81.1769 75.9529 81.2395 77.0609 80.5426 77.7578L77.2759 81.0245L80.5057 84.2543C81.1995 84.861 81.197 85.9473 80.5436 86.6007Z",
    fill: "#C6D4E7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12189_16868",
    x1: 50.9785,
    y1: 105.103,
    x2: 89.7087,
    y2: 26.2851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12189_16868",
    x1: 22.855,
    y1: 31.165,
    x2: 69.0366,
    y2: 88.9778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6D4E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4EFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12189_16868",
    x1: 68.1133,
    y1: 87.974,
    x2: 82.7784,
    y2: 70.0324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F01A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5261C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12189_16868"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 105,
    height: 83,
    fill: "white",
    transform: "translate(22 30)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsExpenses);
export default __webpack_public_path__ + "static/media/es-expenses.43447bcf8aec33751065184e662d6f2e.svg";
export { ForwardRef as ReactComponent };